'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _collections = require('redux/modules/collections');

var collectionActions = _interopRequireWildcard(_collections);

var _reactRedux = require('react-redux');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    collection: state.collections.collection,
    province: state.address.province,
    lists: state.collections.lists,
    total: state.collections.total,
    pageSize: state.collections.pageSize,
    loading: state.collections.loadingDetail,
    loaded: state.collections.loadedDetail
  };
}, (0, _extends3.default)({}, collectionActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CollectionList, _Component);

  function CollectionList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CollectionList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollectionList.__proto__ || (0, _getPrototypeOf2.default)(CollectionList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pageSize: 100, // Dirty hack to show all Collections. TODO: infinity-scroll loading
      lazy: false,
      firstLoad: false,
      sort: ''
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CollectionList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded && this.props.loading !== true || !this.props.lists || !this.state.firstLoad) {
        this.getResult.call(this);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading) {
        this.setState({ firstLoad: true });
      }
      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({ pageSize: nextProps.pageSize });
      }
      if (!nextProps.loading) {
        this.setState({ lazy: false });
      }
    }
  }, {
    key: 'toCollectionDetail',
    value: function toCollectionDetail(collection) {
      _reactGa2.default.event({
        category: 'Collection',
        action: 'Clicked Collection Card',
        label: '' + collection.name
      });
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filter = {
        province: this.props.province,
        pageSize: this.state.pageSize,
        sort: this.state.sort
      };
      this.props.load(filter);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./CollectionPage.scss');
      var lists = this.props.lists;

      return _react2.default.createElement(
        'div',
        { className: styles.pageContainer },
        _react2.default.createElement(
          'div',
          { className: styles.collectionList },
          lists && lists.map(function (collection) {
            return _react2.default.createElement(_components.CollectionCardMobile, {
              item: collection,
              key: collection._id,
              onPress: function onPress() {
                return _this2.toCollectionDetail(collection);
              }
            });
          })
        )
      );
    }
  }]);
  return CollectionList;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  load: _react.PropTypes.func.isRequired,
  collection: _react.PropTypes.object,
  getOneByHandle: _react.PropTypes.func.isRequired,
  total: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  lists: _react.PropTypes.array,
  province: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = CollectionList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Collection/CollectionListMobile.js
// module id = 1549
// module chunks = 0